<template>
    <div class="wrapper">
        <div class=" padding-sm bg-white margin-bottom-sm">
            <div class="flex align-start justify-between margin-bottom-sm">
                <h3 class="page-title line-height">会员基本信息<span v-if="examine_status !== 1" class="status">（{{
                        examine_status | status
                    }}）</span>
                    <span>新录入会员账号和初始密码均为联系人手机号</span></h3>
                <el-button class="blue-btn" round type="primary" @click="$router.go(-1)"
                >返回
                </el-button
                >
            </div>
            <div v-if="examine_status === 3" class="reason margin-top">
                拒绝原因：{{ examine_msg }}
            </div>
            <el-form ref="ruleForm" :model="infoForm" class="ruleForm" label-position="top" label-width="auto">
                <el-row :gutter="20">
                    <el-col v-for="(item,index) in infoForm.list"
                            :key="index" :span="(item.type === 2 || item.type ===6|| item.type ===7) ? 24 : 12">
                        <el-form-item v-if="item.type === 1" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-input v-model="item.answer" :placeholder="item.placeholder || '请输入' + item.title"></el-input>
                        </el-form-item>
                        <el-form-item v-if="item.type === 2" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-input v-model="item.answer" :placeholder="'请输入' + item.title"
                                      type="textarea"></el-input>
                        </el-form-item>
                        <el-form-item v-if="item.type === 3  && !item.hide" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <div v-if="item.field && item.field === 'rankId'">
                                <el-select v-model="item.answer" :placeholder="'请选择' + item.title" class="w-all"
                                           @change="setLevel">
                                    <el-option v-for="option in item.options" :key="option.value"
                                               :label="option.label"
                                               :value="option.value"></el-option>
                                </el-select>
                            </div>
                            <div v-else>
                                <el-select v-model="item.answer" :disabled="item.disabled" :placeholder="'请选择' + item.title"
                                           class="w-all" clearable>
                                    <el-option v-for="option in item.options" :key="option.value"
                                               :label="option.label"
                                               :value="option.value"></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="item.type === 4" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-select v-model="item.answer" :placeholder="'请选择' + item.title" class="w-all"
                                       clearable multiple>
                                <el-option v-for="option in item.options" :key="option.value"
                                           :label="option.label"
                                           :value="option.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="item.type === 5" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-cascader
                                v-model="item.answer"
                                :options="options"
                                expand-trigger="hover"
                                filterable
                                placeholder="请选择单位所在地"
                                style="width: 100%;"
                            >
                            </el-cascader>
                        </el-form-item>
                        <el-form-item v-if="item.type === 6" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <infoUpFile :file="item.answer" :index="index" :limit="item.limit" :type="item.type"
                                        @saveFile="saveFile"/>
                        </el-form-item>
                        <el-form-item v-if="item.type === 7" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <infoUpFile :file="item.answer" :index="index" :limit="item.limit" :type="item.type"
                                        @saveFile="saveFile"/>
                        </el-form-item>
                        <el-form-item v-if="item.type === 8" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-date-picker
                                v-model="item.answer"
                                placeholder="请选择日期"
                                style="width: 100%"
                                type="date"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>


                    <el-col v-if="false" :span="12">
                        <el-form-item label="会员证书编号">
                            <el-input v-model="zhengshu_code" placeholder="请输入会员证书编号"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col v-if="!memberId || preserve_type === 1" :span="24">
                        <div class="flex align-start justify-between margin-top-sm">
                            <h3 class="page-title">会员缴费信息</h3>
                        </div>
                    </el-col>
                    <el-col v-if="!memberId || preserve_type === 1" :span="12">
                        <el-form-item label="会员等级">
                            <el-input v-model="level" disabled placeholder="设置会员等级后显示"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!memberId || preserve_type === 1" :span="12">
                        <el-form-item label="会费金额">
                            <el-input v-model="price" disabled placeholder="设置会员等级后显示"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!memberId || preserve_type === 1" :span="12">
                        <el-form-item label="到期时间" required>
                            <el-date-picker
                                v-model="setEndTime"
                                placeholder="请选择会员到期日期"
                                style="width: 100%"
                                type="date">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label-width="0">
                            <div v-if="user.isBranch && examine_status !== 2" class="flex justify-center">
                                <el-button v-if="preserve_type" class="blue-btn big-btn" @click="saveForm('ruleForm',0)">
                                    临时保存
                                </el-button>
                                <el-button class="blue-btn big-btn" @click="saveForm('ruleForm',1)">保存</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div v-if="memberId && preserve_type === 0" class=" padding-sm bg-white margin-bottom-sm">
            <div class="flex align-start justify-between margin-bottom">
                <h3 class="page-title">会员缴费信息</h3>
                <!--                <el-button v-if="user.isBranch && examine_status !== 2" class="blue-btn" round type="primary"-->
                <!--                           @click="setEndTimeState = true"-->
                <!--                >到期时间修改-->
                <!--                </el-button>-->
            </div>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-input v-model="end_time" class="margin-bottom-sm" placeholder="" readonly>
                        <template slot="prepend">
                            <div class="left-title">到期时间</div>
                        </template>
                    </el-input>
                </el-col>
                <el-col :span="12">
                    <el-input v-model="status" class="margin-bottom-sm" placeholder="" readonly>
                        <template slot="prepend">
                            <div class="left-title">当前状态</div>
                        </template>
                    </el-input>
                </el-col>
                <el-col :span="12">
                    <el-input v-model="rank_name" class="margin-bottom-sm" placeholder="" readonly>
                        <template slot="prepend">
                            <div class="left-title">会员等级</div>
                        </template>
                    </el-input>
                </el-col>
                <el-col :span="12">
                    <!--                    <el-input v-model="pay_amount" class="margin-bottom-sm" placeholder="" readonly>-->
                    <!--                        <template slot="prepend">-->
                    <!--                            <div class="left-title">缴费金额</div>-->
                    <!--                        </template>-->
                    <!--                    </el-input>-->
                </el-col>

            </el-row>
        </div>
        <div v-if="memberId && preserve_type === 0" class="info-container margin-bottom-sm flex-sub">
            <div class="flex align-start justify-between margin-bottom-sm">
                <div class="page-title">缴费信息</div>
                <el-button v-if="examine_status !== 2 && !user.isBranch" class="blue-btn" round type="primary"
                           @click="shoaAddPay"
                >添加缴费
                </el-button>
            </div>
            <div class="ship-list flex flex-direction align-center margin-top">
                <el-table
                    :data="tableData"
                    border
                    header-row-class-name="table-header"
                    style="width: 100%;border-radius: 10px">
                    <el-table-column label="会员身份" prop="name">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.rank_name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="缴费金额（元）" prop="pay_amount">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.pay_amount }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="缴纳日期" prop="add_time">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.add_time }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="到期日期" prop="end_time">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.end_time }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="examine_status !== 2 && !user.isBranch" label="操作" prop="end_time">
                        <template slot-scope="scope">
                            <div class="table-name">
                                <el-button style="color: #e4393c" type="text" @click="delItem(scope.row.id)">删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div v-if="memberId && preserve_type === 0" class=" info-container bg-white margin-bottom-sm">
            <div class="flex align-start justify-between margin-bottom-sm">
                <h3 class="page-title">会员票据信息</h3>
            </div>
            <el-input v-model="invoice_name" class="margin-bottom-sm" placeholder="会员未填写" readonly>
                <template slot="prepend">
                    <div class="left-title">会员姓名</div>
                </template>
            </el-input>
            <el-input v-model="invoice_email" class="margin-bottom-sm" placeholder="会员未填写" readonly>
                <template slot="prepend">
                    <div class="left-title">邮箱</div>
                </template>
            </el-input>
<!--            <el-input v-model="invoice_identifier" class="margin-bottom-sm" placeholder="会员未填写" readonly>-->
<!--                <template slot="prepend">-->
<!--                    <div class="left-title">纳税人识别号</div>-->
<!--                </template>-->
<!--            </el-input>-->
            <el-input v-model="invoice_tel" class="margin-bottom-sm" placeholder="会员未填写" readonly>
                <template slot="prepend">
                    <div class="left-title">手机号码</div>
                </template>
            </el-input>
            <el-input v-model="invoice_address" class="margin-bottom-sm" placeholder="会员未填写" readonly>
                <template slot="prepend">
                    <div class="left-title">联系地址</div>
                </template>
            </el-input>
        </div>
        <div v-if="memberId && preserve_type === 0" class="info-container margin-bottom-sm flex-sub">
            <div class="flex align-start justify-between margin-bottom-sm">
                <div class="page-title">会员积分信息</div>
                <!--                <el-button v-if="examine_status !== 2" class="blue-btn" round type="primary"-->
                <!--                           @click="shoaAddPay">添加积分-->
                <!--                </el-button>-->
            </div>
            <div class="ship-list flex flex-direction align-center">
                <el-table
                    :data="integrals"
                    border
                    header-row-class-name="table-header"
                    style="width: 100%;border-radius: 10px">
                    <el-table-column label="序号" prop="name">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ (page - 1) * limit + scope.$index + 1 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="积分" prop="integral">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.integral }}分
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="获取时间" prop="create_time">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.create_time }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="获取途径" prop="integral_type_name">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.integral_type_name }}
                            </div>
                        </template>
                    </el-table-column>
                    <!--                    <el-table-column v-if="examine_status !== 2" label="操作" prop="end_time">-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                            <div class="table-name">-->
                    <!--                                <el-button style="color: #e4393c" type="text" @click="delItem(scope.row.id)">删除-->
                    <!--                                </el-button>-->
                    <!--                            </div>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                </el-table>
                <el-pagination
                    :current-page.sync="page"
                    :page-size="limit"
                    :total="integral_tatal"
                    background
                    class="page-all margin-top"
                    layout="prev, pager, next, jumper"
                    @current-change="getIntegralDetail">
                </el-pagination>
            </div>
        </div>
        <el-dialog
            :visible.sync="setEndTimeState"
            center
            title="添加缴费"
            width="500px">
            <div class="flex flex-direction align-center">

            </div>
            <el-form ref="timeForm" :model="ruleForm" :rules="rules" class="form" labelWidth="auto">
                <el-form-item label="到期日期" prop="infoEndTime">
                    <el-date-picker
                        v-model="ruleForm.infoEndTime"
                        :picker-options="pickerOptions"
                        placeholder="请选择会员到期日期"
                        style="width: 100%"
                        type="date"
                        value-format="timestamp">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="缴纳日期" prop="startTime">
                    <el-date-picker
                        v-model="ruleForm.startTime"
                        placeholder="请选择缴纳日期"
                        style="width: 100%"
                        type="date"
                        value-format="timestamp">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="缴纳金额" prop="price">
                    <el-input v-model="ruleForm.price" placeholder="请输入缴纳金额">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
    <el-button @click="setEndTimeState = false">取 消</el-button>
    <el-button type="primary" @click="submitForm('timeForm')">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
import infoUpFile from "@/components/InfoUpFile";
import {
    delUserPayLogData,
    getInformation,
    getPayLog,
    getPersonalInformation,
    getRankList,
    memberAdd,
    memberDetail,
    setUserEndTime,
    setUserZhengShuCode
} from "@/api/branch";
import rules from "@/utils/rules";
import {regionData} from "element-china-area-data";
import {zhDate} from "@/utils/utils";
import {patternChange} from "../../../../utils/utils";
import {showOrgFenHui} from "../../../../api/branch";
import {getIntegralDetail} from "../../../../api/member";


export default {
    name: "info",
    data() {
        return {
            memberId: '',
            examine_status: 1,
            examine_msg: '',
            userType: 1,
            infoForm: {
                list: [
                    {
                        type: 1,
                        title: '单位名称',
                        field: 'company',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请输入', trigger: 'blur'}]
                    }, {
                        type: 1,
                        title: '社会统一信用代码',
                        field: 'creditCode',
                        answer: '',
                        options: [],
                        isMust: false,
                        isSet: false,
                        rules: [{required: true, message: '请输入', trigger: 'blur'}, {
                            min: 18,
                            max: 18,
                            message: '社会统一信用代码为18位',
                            trigger: 'blur'
                        }]
                    }, {
                        type: 3,
                        title: '单位性质',
                        field: 'unitNature',
                        answer: '',
                        options: [
                            {value: 4, label: '民营企业'},
                            {value: 3, label: '国有企业'},
                            {value: 15, label: '合资企业'},
                            {value: 10, label: '央企（国资委）'},
                            {value: 11, label: '央企（地方）'},
                            {value: 12, label: '外企（欧美日韩）'},
                            {value: 13, label: '外企（港澳台）'},
                            {value: 14, label: '外企（其他）'},
                            {value: 18, label: '股份'},
                            {value: 20, label: '企业'},
                            {value: 16, label: '科研院所'},
                            {value: 17, label: '行政单位'},
                            {value: 1, label: '机关'},
                            {value: 2, label: '事业单位'},
                            {value: 5, label: '社会团体'},
                            {value: 19, label: '社会服务单位'},
                            {value: 6, label: '民办非企业单位'},
                            {value: 7, label: '基金会'},
                            {value: 8, label: '其他'}
                        ],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请选择', trigger: 'change'}]
                    }, {
                        type: 3,
                        title: '会员等级',
                        field: 'rankId',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请选择', trigger: 'change'}]
                    }, {
                        type: 1,
                        title: '法人姓名',
                        field: 'farenName',
                        answer: '',
                        options: [],
                        isMust: false,
                        isSet: false,
                        rules: [{required: true, message: '请输入', trigger: 'blur'}]
                    }, {
                        type: 1,
                        title: '法人联系电话',
                        field: 'farenPhone',
                        answer: '',
                        options: [],
                        isMust: false,
                        isSet: false,
                        rules: rules.tel
                    }, {
                        type: 1,
                        title: '联系人姓名',
                        field: 'name',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请输入', trigger: 'blur'}]
                    }, {
                        type: 1,
                        title: '联系人电话',
                        field: 'phone',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: rules.tel
                    }, {
                        type: 5,
                        title: '单位地址',
                        field: 'address',
                        answer: [],
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请选择', trigger: 'change'}]
                    }
                ],
            },
            options: regionData,
            levelList: [],
            level: '',
            price: '',
            infoEndTime: null,
            setEndTime: null,
            ruleForm: {
                infoEndTime: null,
                startTime: null,
                price: '',
            },
            rules: {
                infoEndTime: [
                    {required: true, message: '请选择会员到期日期', trigger: 'blur'},
                ],
                startTime: [
                    {required: true, message: '请选择缴纳日期', trigger: 'blur'},
                ],
                price: [
                    {required: true, message: '请输入缴纳金额', trigger: 'blur'},
                    rules.money
                ],

            },

            zhengshu_code: '',
            end_time: '',
            pay_amount: '',
            status: '',
            rank_name: '',
            setEndTimeState: false,


            invoice_name: '',
            invoice_identifier: '',
            invoice_tel: '',
            invoice_address: '',
            invoice_email: '',
            tableData: [],
            pickerOptions: '',
            preserve_type: 0 ,



            integrals: [],
            integral_tatal: 0,
            page: 1,
            limit: 5
        }
    },
    created() {
        this.$emit('setIndex', [3, 0], '会员设置')
        this.memberId = Number(this.$route.params.id)
        this.preserve_type = this.memberId === 0 ? 1 : 0
        this.userType = Number(this.$route.params.type)
        this.getInformation()
        this.getIntegralDetail()
        this.init()
    },
    components: {
        infoUpFile
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            let _list = await getPayLog(this.memberId)
            if (_list.status === 200) {
                _list.data.map(item => {
                    item.add_time = zhDate(item.add_time * 1000)
                    item.end_time = zhDate(item.end_time * 1000)
                })
                this.tableData = _list.data
            }
        },
        async getIntegralDetail() {
            let _data = await getIntegralDetail(this.user.mid,this.memberId,1,this.page,this.limit)
            this.integrals = _data.data
            this.integral_tatal = _data.count
        },
        shoaAddPay() {
            this.setEndTimeState = true
            this.ruleForm.price = this.pay_amount
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.suerEdntime(formName)
                }
            });
        },
        //  设置到期时间
        async suerEdntime() {
            let _state = await setUserEndTime(this.memberId, this.ruleForm.startTime, this.ruleForm.infoEndTime, this.ruleForm.price)
            if (_state.status === 200) {
                this.setEndTimeState = false
                this.$refs.timeForm.resetFields()
                this.$message.success('添加成功')
                this.init()
            }
        },
        delItem(id) {
            this.$confirm('此操作将删除该续费记录, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(id)
            })
        },
        async sureDelete(id) {
            let _state = await delUserPayLogData(id)
            if (_state.status === 200) {
                this.$message.success(_state.msg)
                this.getMemberDetail()
                this.init()
            }
        },
        //  保存表单
        //  保存表单
        saveForm(formName, type) {
            this.$refs[formName].clearValidate()
            if (type) {
                this.sureSave()
                // this.$refs[formName].validate((valid) => {
                //   if (valid) {
                //     if (!this.setEndTime && !this.memberId) return this.$message.error('请选择到期时间')
                //     this.sureSave()
                //   } else {
                //     this.$message.error('信息填写有误，请确认！')
                //   }
                // });
            } else {
                // this.$refs.ruleForm.validateField('list.1.answer', (valid) => {
                //   if (!valid) {
                this.sureSave(1)
                // } else {
                //   this.$message.error('信息填写有误，请确认！')
                // }
                // })
            }
        },
        async sureSave(preserve_type = 0) {
            let _state = await memberAdd(JSON.stringify(this.infoForm.list),
                this.setEndTime ? parseInt(this.setEndTime.getTime() / 1000) : 0,
                this.memberId, this.userType, preserve_type)
            if (_state.status === 200) {
                if (this.memberId) _state = await setUserZhengShuCode(this.memberId, this.zhengshu_code)
                if (_state.status === 200) {
                    this.$message.success('保存成功')
                    this.$router.go(-1)
                }
            }

        },
        setLevel(val) {
            this.levelList.map(item => {
                if (item.id === val) {
                    this.level = item.name
                    this.price = item.price
                }
            })
        },
        //  同步附件信息
        saveFile(val) {
            const _index = val[0]
            this.infoForm.list[_index].answer = val[1]
            this.$set(this.infoForm.list, _index, this.infoForm.list[_index])

        },
        //  获取会员等级列表
        async getLevel() {
            let _data = await getRankList(this.userType)
            _data.data.map(item => {
                item.value = item.id
                item.label = item.name
            })
            this.levelList = _data.data
            // _data = await getfenhuiList(this.user.parent_id,this.user.fhid)
            // _data.data.map(item => {
            //     item.value = item.id
            //     item.label = item.name
            // })
            // let _organizs = _data.data
            _data = await showOrgFenHui(this.user.fhid)
            this.userInfo = _data.data
            this.infoForm.list = patternChange(this.infoForm.list, this.levelList, this.userInfo.name, [], this.userInfo.id)
        },
        //  获取表单
        async getInformation() {
            let _data = this.userType === 1 ? await getInformation() : await getPersonalInformation()
            if (_data.status === 200) this.infoForm.list = JSON.parse(_data.data.user_more_json)
            await this.getLevel()

            if (this.memberId) {
                this.getMemberDetail()
            }
        },
        //  获取会员信息
        async getMemberDetail() {
            let _data = await memberDetail(this.memberId)
            this.zhengshu_code = _data.data.zhengshu_code
            this.invoice_name = _data.data.invoice_name
            this.invoice_identifier = _data.data.invoice_identifier
            this.invoice_tel = _data.data.invoice_tel
            this.invoice_address = _data.data.invoice_address
            this.invoice_email = _data.data.email

            this.examine_status = _data.data.examine_status
            this.examine_msg = _data.data.examine_msg
            this.preserve_type = _data.data.preserve_type
            this.showDetail(JSON.parse(_data.data.user_more_json))
            this.end_time = Number(_data.data.end_time) ? zhDate(new Date(_data.data.end_time * 1000)) : '--'
            if (_data.data.end_time)
                this.pickerOptions = {
                    // disabledDate(time) {
                    //     return time.getTime() < new Date();
                    // }
                }
            this.status = _data.data.status === 1 ? '已缴费' : '未缴费'
            let _str = this.levelList.filter(item => _data.data.rank_id === item.id)
            this.rank_name = _str[0].name
            this.pay_amount = _str[0].price
            this.$refs.ruleForm.clearValidate()
        },
        showDetail(obj) {
            obj.map(item => {
                this.infoForm.list.map(items => {
                    if (item.title === items.title || item.field === items.field || items.field === item.title) {
                        items.answer = item.answer
                    }
                })
            })
        },
    },
    filters: {
        status(type) {
            switch (Number(type)) {
                case 2:
                    return "审核中";
                case 3:
                    return "审核不通过";
                default:
                    return "审核通过";
            }
        }
    },
    watch: {
        setEndTimeState() {
            this.infoEndTime = this.end_time === '--' ? null : new Date(this.end_time)
        }
    },
}
</script>

<style lang="scss" scoped>
.left-title {
    width: 100px;
}

.status {
    font-size: 14px;
    color: #ffb400;
}

.reason {
    padding: 30px;
    background-color: #fff3da;
    border-radius: 6px;
    border: dashed 1px #ffe3ad;
    font-size: 16px;
    color: #ffb400;

}

.info-container {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 23px 30px;

    .input-form-btn {
        width: 200px;
        height: 40px;
        line-height: 40px;
        border-radius: 40px;
        font-size: 16px;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#ff9600, #ff9600);
        background-blend-mode: normal, normal;
        color: #ffffff;
        margin-top: 20px;
        padding: 0;

        &.white {
            background: #ffffff none;
            color: #ff9600;
        }

        &:disabled {
            background: #b4c7e5 none;
        }

        &.disabled {
            background: #b4c7e5 none;
        }
    }

    .table-name {
        font-size: 16px;
        color: #0a2240;
        text-align: center;
    }

    .table-operate {
        text-align: center;

        .operate {
            width: 110px;
            height: 36px;
            line-height: 36px;
            border-radius: 36px;
            font-size: 16px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#ff9600, #ff9600);
            background-blend-mode: normal, normal;
            color: #ffffff;
            padding: 0;

            &.white {
                background: #ffffff none;
                color: #ff9600;
            }

            &:disabled {
                background: #b4c7e5 none;
            }

            &.disabled {
                background: #b4c7e5 none;
            }
        }
    }

}

.page-title {
    span {
        font-size: 14px;
        font-weight: normal;
    }
}
</style>
